import { createContext } from 'react';

// ----------------------------------------------------------------------

export const WorkspaceContext = createContext(undefined);

export const WorkspaceConsumer = WorkspaceContext.Consumer;
